import { IMG_BASE_PATH } from '@/const'
import { motion } from 'motion/react'
import { PlatformMarketingCard } from '../groupPlatformItems'
import { LandingSection } from '../LandingSection'

export function OurEdgeSection({ items }: { items: PlatformMarketingCard[] }) {
  return (
    <LandingSection className="bg-background" eyebrow="Why PwC" title="Our edge">
      <div className="grid gap-6 md:grid-cols-3">
        {items.map((item, index) => {
          const imageSrc = item.card.image ? `${IMG_BASE_PATH}${item.card.image}` : undefined
          const blurb = item.blurb?.trim()

          return (
            <motion.article
              key={item.card.id || item.card.title}
              className="overflow-hidden rounded-xl border border-border bg-card"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.45, delay: index * 0.05 }}
            >
              {imageSrc && (
                <div className="h-40 overflow-hidden bg-muted">
                  <img src={imageSrc} alt="" className="h-full w-full object-cover" />
                </div>
              )}
              <div className="flex flex-col gap-3 p-6">
                <h3 className="text-lg font-semibold text-card-foreground">{item.card.title}</h3>
                <p className="leading-relaxed text-muted-foreground">{item.card.description}</p>
                {blurb && <p className="text-sm leading-relaxed text-muted-foreground">{blurb}</p>}
              </div>
            </motion.article>
          )
        })}
      </div>
    </LandingSection>
  )
}
